import { FocusEvent, MouseEvent } from 'react';

import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import { Button } from '../Button/Button';

export const SkipLink = () => {
	const { translate } = useTranslation();

	const skipLinkStyle = {
		position: 'absolute' as const,
		left: '-9999px',
		zIndex: 999,
	};

	const handleSkip = (e: MouseEvent) => {
		e.preventDefault();

		const modules = document.querySelectorAll('[data-module-index]');
		const moduleArray = Array.from(modules);

		const nextModule = moduleArray.find((module) => {
			const rect = module.getBoundingClientRect();
			return rect.top > window.innerHeight;
		}) as HTMLElement;

		if (nextModule) {
			nextModule.tabIndex = -1;
			nextModule.focus({ preventScroll: true });
			setTimeout(() => {
				nextModule.scrollIntoView({ behavior: 'smooth', block: 'start' });
				nextModule.removeAttribute('tabIndex');
			}, 100);
		}
	};

	return (
		<Button
			variant="outline"
			as="a"
			href="#"
			style={skipLinkStyle}
			onClick={handleSkip}
			onFocus={(e: FocusEvent<HTMLAnchorElement>) => {
				e.currentTarget.style.left = '0';
			}}
			onBlur={(e: FocusEvent<HTMLAnchorElement>) => {
				e.currentTarget.style.left = '-9999px';
			}}
		>
			{translate('accessibility.skipcontent')}
		</Button>
	);
};
